export default function PageHeaderComponent({ children }) {
    return (
        <div className="w-full bg-gray-400 py-3 shadow-inner-2xl">
            <div className="w-11/12 mx-auto text-gray-100 font-semibold uppercase text-sm leading-1">
                {children}
            </div>
        </div>
    )
}
